import { render, staticRenderFns } from "./PropertyBulkDelete.vue?vue&type=template&id=6d628930&scoped=true&"
import script from "./PropertyBulkDelete.vue?vue&type=script&lang=js&"
export * from "./PropertyBulkDelete.vue?vue&type=script&lang=js&"
import style0 from "./PropertyBulkDelete.vue?vue&type=style&index=0&id=6d628930&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d628930",
  null
  
)

export default component.exports